import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendSmsToAll } from '../services/mobileService';

const SmsComponent = () => {
  const [message, setMessage] = useState('');
  const [password, setPassword] = useState('');
  const [passwordPop, setPasswordPop] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await sendSmsToAll(message, password);
    if (response.message) {
      alert('Successfully sent messages!');
    }
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    setPasswordPop(false);
  };

  const handleClosePasswordPopup = () => {
    setPassword('');
    setMessage('');
    navigate(-1);
  };

  return (
    <>
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        {passwordPop && (
          <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="relative bg-white w-[300px] px-5 py-5 rounded-xl shadow-lg text-center">
              <h2 className="text-[20px] font-semibold text-[#1f2937] mt-4 mb-4">
                Enter Master Password
              </h2>
              <span
                onClick={handleClosePasswordPopup}
                role="button"
                aria-label="Close"
                className="
                  absolute
                  top-3
                  right-3
                  text-gray-600
                  text-xl
                  cursor-pointer
                  hover:text-gray-800
                  select-none
                "
              >
                ✕
              </span>

              <form onSubmit={handlePasswordSubmit} className="space-y-4">
                <input
                  type="password"
                  placeholder="Master Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="
                    w-full
                    h-[40px]
                    px-4
                    border
                    border-[#d1d5db]
                    rounded-md
                    text-[15px]
                    text-gray-700
                    placeholder-gray-400
                    focus:outline-none
                    focus:ring-2
                    focus:ring-gray-600
                  "
                />

                <button
                  type="submit"
                  className="
                    w-full
                    h-[40px]
                    bg-[#4CAF50]
                    text-white
                    text-[15px]
                    font-medium
                    rounded-md
                    hover:bg-[#43a047]
                    transition
                  "
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        )}

        {!passwordPop && (
          <div className="relative w-full max-w-lg bg-white rounded-xl shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center">
              Send SMS to All Users
            </h2>

            <form onSubmit={handleSubmit} className="space-y-5">
              <span
                onClick={handleClosePasswordPopup}
                role="button"
                aria-label="Close"
                className="
                  absolute
                  top-3
                  right-3
                  text-gray-600
                  text-xl
                  cursor-pointer
                  hover:text-gray-800
                  select-none
                "
              >
                ✕
              </span>
              <div>
                <label className="block text-sm font-medium text-gray-800 mb-1">
                  Message
                </label>
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Enter message here"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-md font-medium hover:bg-blue-700 transition"
              >
                Send
              </button>
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default SmsComponent;
